import { LS2PAC_Utils } from "@tlc/ls2pac/app/utils/Utils";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { useLocationConfiguration } from "@tlc/ls2pac/components/LocationConfiguration";
import * as React from "react";
import { ResourceDWR } from "../../../../dto/SuggestionResult";
import { Bookjacket, BookjacketProps } from "./Bookjacket";
import { RateAndReview } from "@tlc/ls2pac/components/RateAndReview";
import { Button } from "@mui/material";

export interface ResourceListItemProps {
  resource: ResourceDWR;
  onClickRemove: (event: React.MouseEvent) => void;
  onClickPlaceHold: (event: React.MouseEvent) => void;
}

export interface BookJacketAndRatingProps extends BookjacketProps {}

export const BookJacketAndRating: React.FC<BookJacketAndRatingProps> = ({
  resource,
}) => {
  if (!resource) {
    return null;
  }
  const { average, onClickReview } =
    LS2PAC_Utils.getRatingsConfiguration(resource);
  return (
    <div className="bookjacketContainer clearfix">
      <a
        href={`#section=resource&resourceid=${resource.id}&currentIndex=0&view=fullDetailsDetailsTab`}
      >
        <Bookjacket resource={resource}></Bookjacket>
      </a>
      <div className="ratingsControl">
        <RateAndReview
          resourceId={resource.id}
          averageRating={average}
          onClickReview={onClickReview}
        ></RateAndReview>
      </div>
    </div>
  );
};

interface RowHeaderProps {
  shortTitle: string;
  shortAuthor?: ResourceDWR["shortAuthor"];
  publicationDate?: ResourceDWR["publicationDate"]["publicationDate"];
  resourceId?: ResourceDWR["id"];
}
export const RowHeader: React.FC<RowHeaderProps> = ({
  shortTitle,
  shortAuthor,
  publicationDate,
  resourceId,
}) => {
  const { translate } = useLanguage();
  const pubDate = publicationDate ? "(" + publicationDate + ")" : "";

  return (
    <>
      <h2>
        {resourceId ? (
          <>
            <a
              href={`#section=resource&resourceid=${resourceId}&currentIndex=0&view=fullDetailsDetailsTab`}
            >
              {shortTitle}
            </a>{" "}
            {pubDate}
          </>
        ) : (
          <>
            {shortTitle} {pubDate}
          </>
        )}
      </h2>
      {shortAuthor && (
        <h3>
          {translate("by")} {shortAuthor}
        </h3>
      )}
    </>
  );
};

export interface ResourceRowHeaderProps {
  resource: ResourceDWR;
}
export const ResourceRowHeader: React.FC<ResourceRowHeaderProps> = ({
  resource,
}) => {
  return (
    <RowHeader
      resourceId={resource.id}
      publicationDate={resource?.publicationDate?.publicationDate}
      shortAuthor={resource.shortAuthor}
      shortTitle={resource.shortTitle}
    ></RowHeader>
  );
};

export const ResourceListItem: React.FC<ResourceListItemProps> = ({
  resource,
  onClickRemove,
  onClickPlaceHold,
}) => {
  const { translate } = useLanguage();
  const { locationConfiguration } = useLocationConfiguration();
  const showRequestButton = LS2PAC_Utils.showRequestButton(resource);

  return (
    <>
      <BookJacketAndRating resource={resource}></BookJacketAndRating>
      <div className="resourceContentWrapper lightBorder">
        <div className="resourceContent">
          <ResourceRowHeader resource={resource}></ResourceRowHeader>
          {resource.rtype === 1 && (
            <a
              href={`#section=resource&resourceid=${resource.id}&currentIndex=0&view=allCopiesDetailsTab`}
              className="allCopies availabilityLink"
            >
              {translate("checkAvailability")}
            </a>
          )}
          <ul className="resultActions clearfix">
            {resource.rtype === 1 &&
              showRequestButton &&
              !resource.downloadable &&
              locationConfiguration?.pacSettings?.userActionSettings
                ?.allowOnShelfHolds && (
                <li className="requestButtonHolder">
                  <Button
                    variant="contained"
                    className="requestItem"
                    onClick={onClickPlaceHold}
                  >
                    {translate("placeRequest")}
                  </Button>
                </li>
              )}
            <li>
              <Button className="removeListItem" onClick={onClickRemove}>
                {translate("removeFromList")}
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
